export default __webpack_public_path__ + "static/media/madhumutyam.d28fece8.jpg";